import { render, staticRenderFns } from "./Manutencao.vue?vue&type=template&id=c094a9fa&lang=pug&"
import script from "./Manutencao.vue?vue&type=script&lang=js&"
export * from "./Manutencao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports